<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <div class="topbox mt20 p30 bgfff">
        <h2>书目查询</h2>
        <el-form ref="form">
          <el-form-item>
            <el-select v-model="formdata.type" placeholder="书名" :popper-append-to-body="false" @change="handleChange">
              <el-option label="书名" value="bookName"></el-option>
              <el-option label="责任者" value="author"></el-option>
              <el-option label="出版社" value="publishHouse"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="title" class="itembox">
            <el-input v-model="formdata.title" placeholder="请输入关键字"></el-input>
            <el-button type="primary" @click="searchKey"><i class="el-icon-search"></i>搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <ul class="ul-model4 mt30 clearfix">
        <li v-for="(item, index) in List" :key="index">
          <a class="clearfix" @click.stop="detaillink(item)" >
            <div class="imgbox fl">
              <div class="img" :style="{backgroundImage: 'url('+getImage(item.bookImage)+')'}"></div>
            </div>
            <div class="txtbox fl">
              <h2 class="textover">{{ item.bookName }}</h2>
              <p class="textover" v-if="item.author !== undefined && item.author !== ''">责任者：{{ item.author }}</p>
              <p class="textover" v-if="item.publishHouse !== undefined && item.publishHouse !== ''">出版社：{{ item.publishHouse }}</p>
              <p class="textover" v-if="item.location !== undefined && item.location !== ''">馆藏地点：{{ item.location }}</p>
              <p class="textover" v-if="item.recommendTime !== undefined && item.recommendTime !== ''">推荐时间：{{ getTime(item.recommendTime) }}</p>
              <div class="descstyle" v-if="item.description !== undefined && item.description !== ''">简介：{{item.fold ? maxSclice(item.description) : item.description}}</div>
              <span v-show="isfold(item.description)" class="more" @click.stop="morechange(item)">【{{item.fold ? '展开更多' : '收起'}}】</span>
            </div>
          </a>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="Param.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getbook } from '@/api/information/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import { timeFormat } from '@/utils/validate'
export default {
  name: 'recommendbook',
  meta: {
    showHeader: true
  },
  components: {
    nodata,
    crumbs,
    banner
  },
  data () {
    return {
      fold: true,
      maxLength: 65,
      formdata: {
        title: '',
        type: ''
      },
      Param: {
        menuId: this.$route.query.columnId,
        bookName: '',
        author: '',
        publishHouse: '',
        page: 1,
        limit: 10
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    isfold (val) {
      if (val !== undefined && val !== '') {
        if (val.length < this.maxLength) {
          return false
        } else {
          return true
        }
      }
    },
    maxSclice (v) {
      return v.length > this.maxLength ? v.slice(0, this.maxLength) + '...' : v
    },
    morechange (item) {
      item.fold = !item.fold
    },
    getTime (val) {
      return timeFormat(val, 'yymmdd').replace(/-/g, '/')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    searchKey () {
      this.Param.bookName = ''
      this.Param.author = ''
      this.Param.publishHouse = ''
      if (this.formdata.type !== '') {
        this.Param[this.formdata.type] = this.formdata.title
      } else {
        if (this.formdata.title !== '') {
          this.Param.bookName = this.formdata.title
        } else {
          this.Param.bookName = ''
        }
      }
      this.Param.page = 1
      this.getList()
    },
    handleChange (val) {
      console.log(val)
      this.formdata.type = val
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    getList () {
      getbook(this.Param).then(res => {
        if (res.data.status === 200) {
          this.listTotal = res.data.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          res.data.data.rows.forEach(item => {
            item.fold = true
          })
          this.List = res.data.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    detaillink (item) {
      if (item.link !== undefined && item.link !== '') {
        window.open(item.link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.topbox{
  h2{
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 15px;
  }
  .el-form{
    display: flex;
    border: solid 2px #409EFF;
    .el-form-item{
      margin: 0;
      /deep/ .el-input__inner{
        border-radius: 0!important;
        border: none!important;
      }
      /deep/ .el-select{
        .el-input__inner{
          text-align: center;
        }
      }
      &:nth-child(1){
        width: 10%;
      }
      &:nth-child(2){
        width: 90%;
        .el-form-item__content{
          display: flex;
          position: relative;
          .el-button,
          .el-input{
            border-radius: 0;
          }
          .el-input{
            width: 90%;
          }
          .el-button{
            position: absolute;
            right: -1px;
            top: 0;
            width: 10%;
          }
        }
      }
      .el-input__inner{
        border: none;
      }
    }
  }
}
.ul-model4{
  li{
    a{
      min-height: 210px;
      .imgbox{
        width: 15%;
        height: 210px;
        position: relative;
        .img{
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          background-position: 50%;
          background-size: cover;
        }
        &:before {
          padding-top: 100%;
          content: "";
          display: block;
        }
      }
      .txtbox{
        width: 85%;
        position: relative;
        padding-bottom: 16px;
        h2{
          margin: 0 0 8px;
        }
        p{
          line-height: 24px;
        }
        .descstyle{
          height: auto;
        }
        .more{
          //position: absolute;
          //right: 32px;
          //bottom: 12%;
          display: block;
          text-align: right;
          color: #0089a2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/recommendbook/booklist.vue